import { AuthBrowser } from "./AuthBrowser";
import { AuthNode } from "./AuthNode";
/**
 * Factory for creating authentication services
 */
export class AuthFactory {
    /**
     * Create a browser authentication service
     *
     * @param fetchImpl - The fetch implementation to use
     * @returns A browser authentication service
     */
    static createBrowser(config, fetchImpl) {
        // Use browser's native fetch if not provided
        if (!fetchImpl && typeof window !== "undefined" && window.fetch) {
            fetchImpl = window.fetch.bind(window);
        }
        if (!fetchImpl) {
            throw new Error("No fetch implementation provided. In browser environments, " +
                "window.fetch should be available.");
        }
        return new AuthBrowser(config, fetchImpl);
    }
    /**
     * Create a Node.js authentication service
     *
     * @param config - Configuration options
     * @param fetchImpl - The fetch implementation to use (required in Node.js)
     * @returns A Node.js authentication service
     */
    static createNode(config, fetchImpl) {
        if (!fetchImpl) {
            throw new Error("AuthFactory: No fetch implementation provided. In Node.js environments, " +
                "you must provide a fetch implementation (e.g., node-fetch).");
        }
        return new AuthNode(config, fetchImpl);
    }
    /**
     * Create the appropriate authentication service for the current environment
     * @param options - Options for creating the authentication service
     * @param fetchImpl - The fetch implementation to use (required in Node.js)
     * @returns An authentication service
     */
    static create(options = {}, fetchImpl) {
        // Check if we're in a browser environment
        const isBrowser = typeof window !== "undefined";
        if (isBrowser) {
            return AuthFactory.createBrowser(options.browser, fetchImpl);
        }
        else {
            return AuthFactory.createNode(options.node, fetchImpl);
        }
    }
}
